import { type FC, useState, useRef } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import scrollIntoView from 'scroll-into-view';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import { Link } from 'dibs-elements/exports/Link';

import styles from './DesignSeriesDescription.scss';

type Props = {
    collapsedHeight: number;
    descriptionHtml: string;
    wrapperClass?: string;
};

export const DesignSeriesDescription: FC<Props> = ({
    collapsedHeight,
    descriptionHtml,
    wrapperClass,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isContentExpandable, setIsContentExpandable] = useState(false);
    const contentRef = useRef(null);
    return (
        <div className={wrapperClass} ref={contentRef} data-tn="design-series-description">
            <ExpandingArea
                wrapperClass={styles.expandingAreaWrapper}
                expanded={isExpanded}
                setIsContentExpandable={setIsContentExpandable}
                collapsedHeight={collapsedHeight}
                showGradient={false}
            >
                <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                        __html: descriptionHtml,
                    }}
                />
            </ExpandingArea>
            {isContentExpandable && (
                <Link
                    className={styles.readMoreButton}
                    onClick={() => {
                        if (isExpanded && contentRef && contentRef.current) {
                            scrollIntoView(contentRef.current, { time: 200 });
                        }
                        setIsExpanded(!isExpanded);
                    }}
                    dataTn={isExpanded ? 'ds-description-read-less' : 'ds-description-read-more'}
                >
                    {isExpanded ? (
                        <FormattedMessage
                            id="designSeries.DesignSeriesDescription.readLess"
                            defaultMessage="Read Less"
                        />
                    ) : (
                        <FormattedMessage
                            id="designSeries.DesignSeriesDescription.readMore"
                            defaultMessage="Read More"
                        />
                    )}
                </Link>
            )}
        </div>
    );
};
